import { Button, Td, Tr } from "@chakra-ui/react";
import { Pedido } from "../../utils/interfaces";
import { formatBRL } from "../../utils/currency";
import { api } from "../../libs/axios";

type Props = {
  pedido: Pedido;
  showAgencia?: boolean;
  representanteOnly?: boolean;
  hideFeeDetails?: boolean;
};

export function Item({pedido, showAgencia = false, representanteOnly = false, hideFeeDetails = false}: Props){
  const valorRelatorio = representanteOnly
    ? pedido.valor_base_comissao_representante ?? pedido.valor_total
    : pedido.valor_total;

  const handleClick = async () => {
    try {
      await api.post(`/pedido/${pedido.id}/visualizado`);
    } catch (e) {} finally{
      window.location.href = `/pedido/${pedido.id}`;
    }
  };

  return (
    <Tr cursor={'pointer'} _hover={{ bg: 'yellow.500'}} p={0} className="group" key={`${pedido.id}-lista-relatorio`}>
      <Td _groupHover={{ backgroundColor: "orange", color: "white" }} p={0} textAlign={'center'} fontSize={'sm'}>
        {representanteOnly ? (
          pedido.id
        ) : (
          <Button variant={'link'} onClick={handleClick}>
            {pedido.id}
          </Button>
        )}
      </Td>
      <Td _groupHover={{ backgroundColor: "orange", color: "white" }} p={0} textAlign={'center'} fontSize={'sm'}>{pedido.created_at}</Td>
      {!representanteOnly && (
        <Td _groupHover={{ backgroundColor: "orange", color: "white" }} p={0} textAlign={'center'} fontSize={'sm'}>{pedido.usuario}</Td>
      )}
      {showAgencia && (
        <Td _groupHover={{ backgroundColor: "orange", color: "white" }} p={0} textAlign={'center'} fontSize={'sm'}>
          {pedido.agencia}
        </Td>
      )}
      {!representanteOnly && (
        <Td _groupHover={{ backgroundColor: "orange", color: "white" }} p={0} textAlign={'center'} fontSize={'sm'}>{pedido.forma_pagamento_label}</Td>
      )}
      <Td _groupHover={{ backgroundColor: "orange", color: "white" }} p={0} textAlign={'center'} fontSize={'sm'}>{pedido.status_label}</Td>
      <Td _groupHover={{ backgroundColor: "orange", color: "white" }} p={0} textAlign={'center'} fontSize={'sm'}>{pedido.qnt_bilhetes}</Td>
      {!representanteOnly && !hideFeeDetails && (
        <Td _groupHover={{ backgroundColor: "orange", color: "white" }} p={0} textAlign={'center'} fontSize={'sm'}>{pedido.ordem_trabalho}</Td>
      )}
      {!hideFeeDetails && (
        <Td _groupHover={{ backgroundColor: "orange", color: "white" }} p={0} textAlign={'center'} fontSize={'sm'}>{formatBRL(Number(pedido.comissao ?? 0))}</Td>
      )}
      <Td _groupHover={{ backgroundColor: "orange", color: "white" }} p={0} textAlign={'center'} fontSize={'sm'}>{formatBRL(Number(valorRelatorio))}</Td>
      
    </Tr>
  )
}
